var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-alert",
    {
      staticClass: "mb-0 text-left config-moved-notice",
      attrs: { dense: "", text: "", type: "info", border: "left" },
    },
    [
      _c("div", { staticClass: "body-2 font-weight-medium" }, [
        _vm._v("As configurações foram movidas para uma nova tela"),
      ]),
      _c("div", { staticClass: "caption" }, [
        _vm._v(" Acesse "),
        _c("strong", [_vm._v("Painel de Controle › Configurações Gerais")]),
        _vm.card
          ? _c("span", [
              _vm._v(", card "),
              _c("strong", [_vm._v(_vm._s(_vm.card))]),
            ])
          : _vm._e(),
        _vm._v(". "),
      ]),
      _c(
        "v-btn",
        {
          staticClass: "mt-1 px-1",
          attrs: { "x-small": "", text: "", color: "info" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.goToNewScreen.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(" Abrir nova tela "),
          _c("v-icon", { attrs: { "x-small": "", right: "" } }, [
            _vm._v("mdi-open-in-new"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }